import { Modal } from "react-bootstrap"
import { useMutation } from "react-query"
import { toast } from "react-toastify"
import { createCampaign } from "../../../../models/tunjangan-hari-karya"
import CampaignForm from "./CampaignForm"


const CreateCampaignModal = ({ queryClient, queryKey, campaign, show, onHide }) => {
    const { mutate, isLoading } = useMutation(data => createCampaign(data), {
        onSuccess: () => {
            queryClient.invalidateQueries([queryKey])
            toast.success('Campaign created')
            onHide()
        },
        onError: error => toast.error(error?.response?.data?.message)
    })

    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Create Campaign</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CampaignForm
                    onSubmit={data => mutate(data)}
                    isSubmitLoading={isLoading}
                />
            </Modal.Body>
        </Modal>
    )
}

export default CreateCampaignModal